import { FC } from 'react';
import { ReactComponent as InfoIcon } from 'assets/icons/info.svg';
import ReactTooltip from 'react-tooltip';

const OPTIMIZE_SCHEDULE_TOOLTIP_MESSAGE =
  'When Optimize Hygiene Schedule is turned on, patients can only ' +
  'schedule 1/2/3 appointment slots before or after the appointment ' +
  'that is available. This ensures a tighter schedule for providers ' +
  'and reduces idle time.';

interface ProfileInfoProps {
  title: string;
  data: string;
  isEdit?: boolean;
  isOptional?: boolean;
  isOptimizeScheduleField?: boolean;
  isTooltipDisplayed?: boolean;
  tooltipId?: string;
  tooltipContent?: string;
}

interface ProfileInfoTooltipProps {
  id: string;
  content: string;
  isFixedWidth?: boolean;
}

const ProfileInfoTooltip: FC<ProfileInfoTooltipProps> = ({
  id,
  content,
  isFixedWidth,
}) => (
  <>
    <button data-for={id} data-tip="">
      <InfoIcon className="w-2 h-2 all-child:fill-mid-grey" />
    </button>
    <ReactTooltip
      id={id}
      effect="solid"
      place="bottom"
      className={`!bg-white !rounded-[0.8rem] !h-[auto] z-[9999] flex justify-center items-center !opacity-100 shadow-elevation-07 after:!border-b-white ${
        isFixedWidth ? '!w-[26.8rem]' : '!max-w-[26.8rem] !whitespace-normal'
      }`}
    >
      <span className="text-11 text-darkest-grey flex items-center font-normal">
        {content}
      </span>
    </ReactTooltip>
  </>
);

const ProfileInfo: FC<ProfileInfoProps> = ({
  title,
  data,
  isEdit,
  children,
  isOptional,
  isOptimizeScheduleField,
  isTooltipDisplayed,
  tooltipId,
  tooltipContent,
}) => {
  const isCenterTitle = isEdit && title !== 'Bio';
  return (
    <div className={`flex gap-x-5 ${isCenterTitle ? 'items-center' : ''}`}>
      <h3
        className={`font-bold w-[20rem] relative flex items-center gap-x-0.5 ${
          isOptimizeScheduleField ? 'self-start' : ''
        }`}
      >
        {title}{' '}
        {!isOptional && isEdit && <span className="text-mid-grey">*</span>}
        {isTooltipDisplayed && isEdit && (
          <ProfileInfoTooltip
            id="optimized-schedule"
            content={OPTIMIZE_SCHEDULE_TOOLTIP_MESSAGE}
            isFixedWidth
          />
        )}
        {tooltipId && tooltipContent && (
          <ProfileInfoTooltip
            id={tooltipId}
            content={tooltipContent}
            isFixedWidth
          />
        )}
      </h3>
      {isEdit ? children : <p className="flex-1 max-w-[36rem]">{data}</p>}
    </div>
  );
};

export default ProfileInfo;
